// extracted by mini-css-extract-plugin
export default {"formCheckbox":"form-checkbox_formCheckbox__yBkkI","checkMark":"form-checkbox_checkMark__eApFk","disabled":"form-checkbox_disabled__EF-ko"};